import {connect} from 'react-redux';

import {TimelineVariationsEnum} from '../../../../../../libs/shared/core/src/store/timelineVariations/timelineVariationsTypes';
import {createSelector, makeMapStateToProps} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {ConversationModel} from '../../../../../models/api/conversationModel';
import {AppState} from '../../../../../store/appState';
import {makeGetVisualRecipient} from '../../../../../store/data/contacts/recipientsSelectors';
import {makeGetConversationChannels} from '../../../../../store/data/conversations/conversationsSelectors';
import {computeTimelineVariation} from '../../../../../store/timelineVariations/timelineVariationSelectors';
import {ChatPrecog} from './chatPrecog';

/*
 * Props.
 */

interface ChatPrecogContainerProps {
  conversation: ConversationModel;
  teammateId: number;
  timelineVariation: TimelineVariationsEnum;
}

/*
 * Selectors.
 */

function getConversation(_state: AppState, props: ChatPrecogContainerProps) {
  return props.conversation;
}

function getTeammateId(_state: AppState, props: ChatPrecogContainerProps) {
  return props.teammateId;
}

function makeGetTimelineVariation(
  getConversationChannels: ReturnType<typeof makeGetConversationChannels<ChatPrecogContainerProps>>,
) {
  return createSelector([getConversationChannels], (channels) => {
    if (!channels) {
      return TimelineVariationsEnum.ASYNCHRONOUS;
    }

    // If every channel tied to a conversation is synchronous, then return synchronous.
    return channels.every((c) => computeTimelineVariation(c) === TimelineVariationsEnum.SYNCHRONOUS)
      ? TimelineVariationsEnum.SYNCHRONOUS
      : TimelineVariationsEnum.ASYNCHRONOUS;
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<ChatPrecogContainerProps>()(() => {
  const getConversationChannels = makeGetConversationChannels(getConversation);
  const getTimelineVariation = makeGetTimelineVariation(getConversationChannels);
  return {
    recipient: makeGetVisualRecipient(getConversation, getTeammateId, 'chatPrecogContainer'),
    timelineVariation: getTimelineVariation,
  };
});

export const ChatPrecogContainer = connect(mapStateToProps)(ChatPrecog);
